import { adminHttpClient } from '../commons/adminHttpClient'

export interface StateValues {
  id: string
  name: string
}

const statesApi = (): Promise<StateValues[]> => {
  return adminHttpClient.get('/Address/States')
}

export default statesApi
